import _classCallCheck from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import "core-js/modules/es.typed-array.sort.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Geometry } from '../core/Geometry.js';
export var Triangle = /*#__PURE__*/function (_Geometry) {
  _inherits(Triangle, _Geometry);

  var _super = _createSuper(Triangle);

  function Triangle(gl) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$attributes = _ref.attributes,
        attributes = _ref$attributes === void 0 ? {} : _ref$attributes;

    _classCallCheck(this, Triangle);

    Object.assign(attributes, {
      position: {
        size: 2,
        data: new Float32Array([-1, -1, 3, -1, -1, 3])
      },
      uv: {
        size: 2,
        data: new Float32Array([0, 0, 2, 0, 0, 2])
      }
    });
    return _super.call(this, gl, attributes);
  }

  return Triangle;
}(Geometry);